<script>
import Multiselect from 'vue-multiselect'

import { apiSecond } from '@/boot/axios'

const LOCALE_SUFFIX = {
	ru: '',
	kz: '_kaz',
}

export default {
	name: 'CatchFishType',
	components: {
		Multiselect,
	},
	data() {
		return {
			array: [],
		}
	},
	props: {
		modelValue: {
			type: [Number, String, Array],
			default: null,
		},
		value: {
			type: [Number, String, Array, Object],
			default: null,
		},
		errors: {
			type: Object,
			default: null,
		},
		title: {
			type: String,
			default: null,
		},
		subtitle: {
			type: String,
			default: null,
		},
		required: {
			type: Boolean,
			default: false,
		},
		trackBy: {
			type: String,
			default: 'id',
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
		},
		placeholder: {
			type: String,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update:modelValue', 'update:modelObjectsName', 'input'],
	watch: {
		categoryValue() {
			this.$emit('update:modelValue', null)
		},
	},
	computed: {
		// Use value prop if provided, otherwise fall back to modelValue
		selectedValue() {
			return this.value !== null ? this.value : this.modelValue
		},
		displayValue() {
			if (this.multiple) {
				if (!this.selectedValue?.length) return []

				return this.selectedValue?.map((id) => {
					return this.array.find((e) => e.id === id)
				})
			}

			return this.array.find((e) => e.id === this.selectedValue)
		},
		formList() {
			return this.array
		},
		getLabel() {
			return (key) => {
				return key + LOCALE_SUFFIX[this.$i18n.locale]
			}
		},
	},
	beforeMount() {
		this.apiGetCatchTypesList()
	},
	methods: {
		apiGetCatchTypesList() {
			apiSecond
				.get('/v2/handbook-fish-type-catches')
				.then((response) => {
					if (response.data && response.data.data) {
						this.array = response.data.data
					}
				})
				.catch((error) => {
					if (error.response) {
						if (error?.response?.status == 500) {
							this.errorMessage.status = 500
							this.errorMessage.text = this.$t('system_message.500')
						}
						if (error?.response?.status == 401) {
							this.errorMessage.status = 401
							this.errorMessage.text = error.response.data.error_message
							this.$router.push('/' + this.$i18n.locale + '/login')
						}
						if (error?.response?.status == 422) {
							this.errorMessage.status = 422
							this.errorMessage.text = error.response.data.error_message
						}
					}
				})
		},
		update(value) {
			if (value && !this.multiple) {
				this.$emit('update:modelValue', value.id)
				this.$emit('input', value.id)
				this.$emit('update:modelObjectsName', value.name)
			} else if (value) {
				this.$emit('update:modelValue', this.idValues(value))
				this.$emit('input', this.idValues(value))
				this.$emit('update:modelObjectsName', this.idNames(value))
			} else {
				this.$emit('update:modelValue', null)
				this.$emit('input', null)
			}
		},
		idNames(array) {
			return array.map((element) => element.name)
		},
		idValues(array) {
			return array.map((element) => element.id)
		},
	},
}
</script>

<template>
	<div class="input-wrapper">
		<div v-if="title" class="title">
			{{ title }}
			<span v-if="subtitle">
				<br />
				{{ subtitle }}
			</span>
		</div>
		<div class="input-body" :class="{ 'input-body--error': errors && errors.$error }">
			<multiselect
				:value="displayValue"
				:max-height="200"
				:max="3"
				:options="formList"
				:preserve-search="true"
				:multiple="multiple"
				:close-on-select="!multiple"
				:disabled="disabled"
				:placeholder="placeholder"
				:track-by="trackBy || ''"
				:label="getLabel('title')"
				:required="required"
				class="multiselect__check"
				@input="update"
			>
				<template slot="singleLabel" slot-scope="{ option }">{{ option.title }}</template>
				<template slot="noResult">{{ $t('components.not_found') }}</template>
				<template slot="noOptions">{{ $t('components.not_found') }}</template>
				<template slot="placeholder">{{ placeholder || $t('placeholder.choose') }}</template>
			</multiselect>
			<input type="hidden" :name="name" :value="value.id" v-if="value && !multiple" />
			<input type="hidden" :name="name" :value="'[' + idValues(value) + ']'" v-else-if="value" />
		</div>
		<div class="input-required" v-if="errors && !errors.required">
			{{ $t('system_message.required_message') }}
		</div>
	</div>
</template>

<style scoped>
.title {
	font-weight: 600;
	font-size: 12px;
	color: #0a091d;
	margin-bottom: 8px;
	line-height: 1.2;
}

.title span {
	color: #708295;
}

.input-body .multiselect__tags {
	padding-left: 20px;
	border: 1px solid #0a091d;
	border-radius: 5px;
	background: #ffffff;
	border: 1px solid #157fee !important;
	font-weight: 400;
	font-size: 14px;
	color: #0a091d;
	line-height: 1.2;
	width: 100%;
}

.input-body .multiselect--disabled .multiselect__tags {
	border: 1px solid #d3e7fb;
}

.input-body .multiselect--disabled .multiselect__placeholder {
	margin-bottom: 0;
}

.input-body .multiselect__single {
	margin-bottom: 0;
}

.input-body--error.input-body .multiselect__tags {
	border-color: #f3574d;
}

.input-body--error + .input-required {
	display: block;
}
</style>
